<template>
    <div>
        <div class="container m_container ch-gw-animation">
            <div class="row" style="padding-top: 3rem;padding-bottom: 3rem;">

                <div style="width: 100%;margin: 0 auto;display: flex;flex-wrap: wrap;" class="" v-for="(item,index) in couresList">
                    <div style="width: 48%;" v-if="index%2 !== 0">
                    
                    </div>
                    
                    <div style="width: 4%;position: relative;display: flex;justify-content: center;" v-if="index%2 !== 0">
                        <div style="width: 1%;background-color: rgba(0, 0, 0, 0.2);min-height: 7rem;"></div>
                        <div style="width: 0.6rem;height: 0.6rem;border-radius: 1rem;background-color: rgb(44,143,241);position: absolute;top: 0;bottom: 0;margin:auto"></div>
                    </div>

                    <div style="width: 48%;position: relative;display: flex;flex-wrap: wrap;align-items: center;">
                        <div :class="{'develop-right':index%2 == 0,'develop-left':index%2 !== 0}">
                            <div style="width: 100%;text-align: start;">
                                <span class="develop_font_par">{{ item.yearsValue.replaceAll("-",".") }}</span>
                               
                            </div>
                            <div class="develop_font_text" >
                                {{ item.textarea }}
                            </div>
                        </div>
                    </div>

                    <div style="width: 4%;position: relative;display: flex;justify-content: center;" v-if="index%2 == 0">
                        <div style="width: 1%;background-color: rgba(0, 0, 0, 0.2);min-height: 7rem;"></div>
                        <div style="width: 0.6rem;height: 0.6rem;border-radius: 1rem;background-color: rgb(44,143,241);position: absolute;top: 0;bottom: 0;margin:auto"></div>
                    </div>

                    <div style="width: 48%;" v-if="index%2 == 0"></div>

                </div>

            </div>
      </div>
    </div>
</template>

<script>
import {queryCoures } from "@/utils/gw";
export default {
  components:{

  },
  name: 'patent',
  data () {
    return {
      msg: '首页',
      patentImaage:26,
      couresList:[],
    }
  },
  mounted() {
    this.queryCoures();
  },
  methods:{
    queryCoures(){ 
        queryCoures().then((e)=>{
            e.data.coures.sort(function(a,b){
                return new Date(a.yearsValue).getTime() < new Date(b.yearsValue).getTime() ? 1 : -1
            });
            this.couresList = e.data.coures
            
        })
    }
  }
}
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// src/components/about/development.vue